import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { DynamicWidgets } from 'react-instantsearch';

import { SearchFacetMenuSelect } from '@uncinc/react-searchkit';

import { facetAttributes } from '../config';

import './style.scss';

export interface SearchPromotedContentThemesAdvancedFacetsProps {
  className?: string;
}

// eslint-disable-next-line max-len
const SearchPromotedContentThemesAdvancedFacets: React.FC<SearchPromotedContentThemesAdvancedFacetsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchPromotedContentThemes__AdvancedFacets', className);

  return (
    <div className={classNames}>
      <h2 className="asCaption">
        {t('general.filter')}
      </h2>

      <div className="SearchPromotedContentThemes__AdvancedFacets__facets">
        <DynamicWidgets>
          {facetAttributes.slice(1).map((facetAttribute) => {
            const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

            return (
              <SearchFacetMenuSelect
                key={attribute}
                attribute={attribute}
                placeholder={t(`placeholders.field_${attribute}.placeholder`)}
                sortBy={attribute === 'year' ? ['name:desc'] : undefined}
              />
            );
          })}
        </DynamicWidgets>
      </div>
    </div>
  );
};

export default SearchPromotedContentThemesAdvancedFacets;
